import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Flex, Text } from 'onefaceui-react-components';

import {
  formatDateOnlyMonth,
  getResourceTo
} from 'react/utils/utils';

import RouteStatusIcon from './RouteStatusIcon';

function RouteStatus({ route }) {
  const { startRoute } = useMemo(() => {
    const { actualStart } = route;

    return {
      startRoute: formatDateOnlyMonth(actualStart)
    };
  }, [route]);

  const startRouteTooltip = getResourceTo('routemonitor.routestart');

  return (
    <Flex alignItems="center" gap={4}>
      <RouteStatusIcon route={route} />
      <Flex alignItems="center">
        <Text title={startRouteTooltip} size="sm" weight="bold">
          {getResourceTo('routeview')} {route?.key}{' '}
          {startRoute && `(${startRoute})`}
        </Text>
      </Flex>
    </Flex>
  );
}

RouteStatus.propTypes = {
  route: PropTypes.object.isRequired
};

export default RouteStatus;
